module.exports = __webpack_public_path__ + "static/media/sologo_espacamento_menor.c8aa29ae.png";